<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button class="mr-3" v-if="$checkRole($accessModule.tax_and_versioning, 'create')" label="CREATE NEW VERSION" @click="openCreateNewVersion" outline></gofix-button>
<!--                        <gofix-button v-if="$checkRole($accessModule.tax_and_versioning, 'update')" label="SAVE" @click="save"></gofix-button>-->
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card class="mb-0" classContent="mb-0 mt-4" title="Related Versions" fullContent>
                                <gofix-table 
                                    :settings="tableConfig" 
                                    :table-items="tableItems" 
                                    @load-items="getTableData"
                                    @row-click="openDetail"
                                    ref="gofixTable">
                                    <template slot="gofix_table:tax_code" slot-scope="row">
                                        {{row.item.tax_code}} <span style="font-size:11px; color: #F05600;" v-if="row.item.is_current">(active)</span>
                                    </template>
                                    <template slot="gofix_table:rate" slot-scope="row">
                                        {{row.item.rate ? parseFloat(parseFloat((row.item.rate)*100).toFixed(2)) + '%' : "--" }}
                                    </template>
                                    <template slot="gofix_table:effective_date" slot-scope="row">
                                        {{row.item.effective_date ? row.item.effective_date : "" | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                                    </template>
                                    <template slot="gofix_table:Country" slot-scope="row">
                                        Singapore
                                    </template>
                                </gofix-table>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
      <b-modal :no-close-on-backdrop="true" id="modal-Create" v-model="modals.detail.open" :title="modals.detail.title" hide-footer :centered="true" ref="modal-Create">
        <b-form class="pb-20">
          <gofix-form-input :disabled="true" label="Tax Code"  v-model="modals.detail.data.tax_code">
          </gofix-form-input>
          <gofix-form-input label="Description" v-model="modals.detail.data.description"></gofix-form-input>
          <b-row>
            <b-col md="6">
              <gofix-form-input-number label="Rate [%]" v-model="modals.detail.data.rate" :integer-limit="3" :include-thousands-separator="false"></gofix-form-input-number>
            </b-col>
            <b-col md="6">
              <gofix-form-input-date v-model="modals.detail.data.effective_date" label="Effective Start Date">
              </gofix-form-input-date>
            </b-col>
          </b-row>
        </b-form>
        <b-button-group class="d-block text-right">
          <gofix-button label="SUBMIT" :loading="modals.detail.loading" @click="saveTax" noBorder :disabled="!$checkRole($accessModule.tax_and_versioning, 'update')"></gofix-button>
        </b-button-group>
      </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';;
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'tax-detail',
    data() {
        return {
            tabData: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            }, ],
            tableConfig: {
                name: 'master-tax',
                controls: {
                    create: false,
                    delete: false,
                    tableFilter: false,
                },
                filter: {},
                page: 1,
                limit: 100,
                total: 0,
                fields: [{
                        key: 'tax_code',
                        label: 'Tax Code',
                        thStyle: 'width:250px',
                        isActive: 1,
                        isFilter: false
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        isActive: 1,
                        isFilter: false
                    },
                    {
                        key: 'rate',
                        label: 'Rate [%]',
                        isActive: 1,
                        isFilter: true
                    },
                    {
                        key: 'effective_date',
                        label: 'Effective Start Date',
                        isActive: 1,
                        isFilter: false
                    },
                    {
                        key: 'Country',
                        label: 'Country',
                        thStyle: 'width:150px',
                        isActive: 1,
                        isFilter: false
                    }
                ],
                sortColumn: null,
                sortDirection: "asc",
            },
            tableItems: [],
            loading: {
                isServiceLoading: false,
                listing: false
            },
            pages: {
                isCMS: '1',
                limit: 100,
                page: 1,
                contract_id: this.$route.params.id,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['related_tax']))
            },
            columnActive: {
                fields: [
                    /*{
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        isActive: 1
                    },*/
                    {
                        key: 'tax_code',
                        label: 'Tax Code',
                        thStyle: 'width:150px',
                        isActive: 1,
                        isFilter: true
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        isActive: 1,
                        isFilter: true
                    },
                    {
                        key: 'rate',
                        label: 'Rate [%]',
                        isActive: 1,
                        isFilter: true
                    },
                    {
                        key: 'effective_date',
                        label: 'Effective Start Date',
                        isActive: 1,
                        isFilter: true
                    },
                    {
                        key: 'Country',
                        label: 'Country',
                        thStyle: 'width:150px',
                        isActive: 1,
                        isFilter: true
                    }

                ],
                show: [],
                hide: []
            },
            effective_date: null,
          modals:{
              detail: {
                open: false,
                loading: false,
                title: 'Create new version',
                data:{
                  id: null,
                  tax_code: '',
                  description: '',
                  rate: '',
                  effective_date: new Date(),
                }
              }
          }
        }
    },
    computed: {
        ...mapGetters({
            taxDetail: 'TaxVersioningController/taxDetail',
            ClientContractID: 'ContractController/ClientContractID',
            relatedTax: 'TaxVersioningController/relatedTax'
        })
    },
    //Effective date must be greater than or equal to the current date.
    watch: {
        "taxDetail.effective_date": function(val, old) {
            let now = moment(new Date()).format('YYYY-MM-DD');
            let value = moment(new Date(val)).format('YYYY-MM-DD');
            if (val && old && this.effective_date && moment(now).isAfter(value)) {
                this.taxDetail.effective_date = this.effective_date;
                if (
                    (
                        moment(now).isAfter(moment(new Date(this.effective_date)).format('YYYY-MM-DD')) &&
                        !moment(moment(value)).isSame(moment(new Date(this.effective_date)).format('YYYY-MM-DD'))
                    ) ||
                    (
                        !moment(now).isAfter(moment(new Date(this.effective_date)).format('YYYY-MM-DD'))
                    )
                ) {
                    return this.$alertNotification("Effective date must be greater than or equal to the current date.", "danger");
                }
            } else {
                this.effective_date = val;
            }
        }
    },
    created() {
        if (this.ClientContractID && !this.contractTerms && this.ClientContractID.contract_terms) {
            this.contractTerms = this.ClientContractID.contract_terms[0];
        }

        if (this.$route.params.tax_id) {
            this.$store.dispatch("TaxVersioningController/getDetail", this.$route.params.tax_id)
                .then(result => {
                    this.effective_date = result.effective_date
                });
            this.reloadRelatedTax()
        }
    },
    methods: {
        refresh() {
            this.pages.filter = JSON.parse(JSON.stringify(filters['related_tax']));
            this.pages.page = 1;
            this.reloadRelatedTax();
        },
        reloadRelatedTax() {
            this.loading.listing = true
            this.$store.dispatch("TaxVersioningController/getRelatedTax", { tax_id: this.$route.params.tax_id, pages: this.pages }).then(response => {
                this.pages.totalPage = Math.ceil(response.total / this.pages.limit);
                this.loading.listing = false;
            });
        },
        createNewVersion() {
            if (this.taxDetail.id == "0") {
                return this.$alertNotification("Cannot create new version of new tax!", "danger");
            }
            if (this.modals.detail.data.rate > 100) {
                return this.$alertNotification("Maximum tax rate of 100.", "danger");
            }
            let request = Object.assign({tax_name:this.taxDetail.tax_name}, this.modals.detail.data);
            request.id = this.taxDetail.id;
            if (request.effective_date) request.effective_date = moment(request.effective_date).format('YYYY-MM-DD');
            if(this.modals.detail.loading) return ;
            this.modals.detail.loading = true
            this.$store.dispatch("TaxVersioningController/createNewVersion", request)
                .then(result => {
                    this.$alertNotification(this.$notificationV2('adding', 'tax'));
                    this.$store.dispatch("TaxVersioningController/getDetail", this.$route.params.tax_id);
                    this.$refs.gofixTable.reloadTableKeepFilter();
                  this.modals.detail.loading = false
                  this.modals.detail.open = false
                })
                .catch(error => {
                  this.modals.detail.loading = false
                    if (error.response && error.response.data.error.message) {
                        this.$alertNotification(error.response.data.error.message, "danger");
                    }
                });
        },
        save() {
            if (!this.modals.detail.data.tax_code) {
                return this.$alertNotification("Tax Code is a required field.", "danger");
            }
            if (!this.modals.detail.data.rate) {
                return this.$alertNotification("Rate is a required field.", "danger");
            }
            if (this.modals.detail.data.rate > 100) {
                return this.$alertNotification("Maximum tax rate of 100.", "danger");
            }
            if (!this.modals.detail.data.effective_date) {
                return this.$alertNotification("Effective Start Date is a required field.", "danger");
            }
            let request = Object.assign({}, this.modals.detail.data);
            if (request.effective_date) request.effective_date = moment(request.effective_date).format('YYYY-MM-DD');
            request.rate = Number(request.rate);
          if(this.modals.detail.loading) return ;
          this.modals.detail.loading = true
            this.$store.dispatch("TaxVersioningController/saveTax", request)
                .then(async result => {
                    await this.$refs.gofixTable.reloadTableKeepFilter();
                    await this.$alertNotification(this.$notificationV2('editing', 'tax'));
                  this.modals.detail.loading = false
                  this.modals.detail.open = false
                })
                .catch(error => {
                    console.log(error);
                  this.modals.detail.loading = false
                    if (error.response && error.response.data.error.message) {
                        this.$alertNotification(error.response.data.error.message, "danger");
                    }
                });
        },
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store.dispatch("TaxVersioningController/getRelatedTax", { tax_id: this.$route.params.tax_id, pages: tableRequest })
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the tax version", "danger");
                    reject();
                })
        },
      openDetail(item){
        this.modals.detail.title = "Update tax version"
        this.modals.detail.open = true
        this.modals.detail.data = {
          id: item.id,
          tax_code: item.tax_code,
          description: item.description,
          rate: (item.rate * 100).toFixed(0),
          effective_date: new Date(item.effective_date)
        }
      },
      openCreateNewVersion(){
        this.modals.detail.title = "Create new version"
        this.modals.detail.open = true
        this.modals.detail.data = {
          id: null,
          tax_code: this.taxDetail.tax_code,
          description: '',
          rate: '',
          effective_date: new Date(),
        }
      },
      saveTax(){
        if(this.modals.detail.data.id){
          this.save()
        }else{
          this.createNewVersion()
        }
      }
    }
}
</script>